import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotification, useTimeZone } from '../../../../../hooks'
import {
  createTask,
  getTaskCreationSuccessNotificationProps,
  TaskFormModal,
} from '../../../../Task'

import {
  getCalendarViewPeriodKey,
  getCalendarViewTaskInitialValues,
  getIsCalendarViewTaskNoteShown,
  getIsCalendarViewTaskNoteStale,
  getIsCalendarViewTaskOutOfCalendar,
} from './useCalendarViewTaskCreate.utils'

export function useCalendarViewTaskCreate({
  calendar,
  setModal,
  onClose,
  onReload,
}) {
  const { t } = useTranslation()

  const { handleAddNotification } = useNotification()

  const timezone = useTimeZone()

  const [notePeriodKey, setNotePeriodKey] = useState(null)

  // The note of a task the calendar leaves out goes on the next navigation, and a return to its period does not bring it back (CAL-01 §7.1a)
  if (getIsCalendarViewTaskNoteStale({ calendar, notePeriodKey })) {
    setNotePeriodKey(null)
  }

  function handleSuccessTaskCreate(data) {
    onClose()
    handleAddNotification(
      getTaskCreationSuccessNotificationProps({ ...data, t })
    )
    onReload()
    setNotePeriodKey(
      getIsCalendarViewTaskOutOfCalendar(data)
        ? getCalendarViewPeriodKey(calendar)
        : null
    )
  }

  function handleOpenTaskCreate() {
    setModal(
      <TaskFormModal
        initialValues={getCalendarViewTaskInitialValues({ calendar, timezone })}
        onClose={onClose}
        onSubmit={createTask}
        onSuccess={handleSuccessTaskCreate}
      />
    )
  }

  return {
    handleOpenTaskCreate,
    isTaskNoteShown: getIsCalendarViewTaskNoteShown({
      calendar,
      notePeriodKey,
    }),
  }
}
